import { useState } from 'react';
import { specializationOptions } from './trainerData';
import '../../owner/ownerPages.css';
import '../../owner/subscriptions/subscriptions.css';
import './trainers.css';

const emptyForm = {
  name: '',
  email: '',
  phone: '',
  specialization: specializationOptions[0],
  branch: '',
  salary: '',
  certifications: '',
  status: 'active',
};

function TrainerForm({ initialData, branchOptions = [], branchReadOnly = false, onSubmit, onCancel, submitLabel }) {
  const [form, setForm] = useState({
    ...emptyForm,
    branch: branchOptions[0] || '',
    ...initialData,
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setForm((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    onSubmit?.({
      ...form,
      salary: Number(form.salary),
      certifications: form.certifications
        .split('\n')
        .map((c) => c.trim())
        .filter(Boolean),
    });
  };

  return (
    <form className="subscription-form" onSubmit={handleSubmit}>
      <div className="trainer-form-grid">
        <div className="owner-form-group">
          <label className="owner-form-label" htmlFor="name">Full Name</label>
          <input id="name" name="name" className="owner-form-input" value={form.name} onChange={handleChange} required />
        </div>
        <div className="owner-form-group">
          <label className="owner-form-label" htmlFor="email">Email</label>
          <input id="email" name="email" type="email" className="owner-form-input" value={form.email} onChange={handleChange} required />
        </div>
        <div className="owner-form-group">
          <label className="owner-form-label" htmlFor="phone">Phone</label>
          <input id="phone" name="phone" type="tel" className="owner-form-input" value={form.phone} onChange={handleChange} required />
        </div>
        <div className="owner-form-group">
          <label className="owner-form-label" htmlFor="specialization">Specialization</label>
          <select id="specialization" name="specialization" className="owner-form-select" value={form.specialization} onChange={handleChange}>
            {specializationOptions.map((opt) => (
              <option key={opt} value={opt}>{opt}</option>
            ))}
          </select>
        </div>
        <div className="owner-form-group">
          <label className="owner-form-label" htmlFor="branch">Branch</label>
          {branchReadOnly ? (
            <input
              id="branch"
              name="branch"
              className="owner-form-input"
              value={form.branch || 'Not assigned'}
              readOnly
              aria-readonly="true"
              title="Branch is assigned by your administrator"
            />
          ) : (
            <select id="branch" name="branch" className="owner-form-select" value={form.branch} onChange={handleChange}>
              {branchOptions.map((opt) => (
                <option key={opt} value={opt}>{opt}</option>
              ))}
            </select>
          )}
        </div>
        <div className="owner-form-group">
          <label className="owner-form-label" htmlFor="salary">Salary (Rs)</label>
          <input id="salary" name="salary" type="number" min="0" className="owner-form-input" value={form.salary} onChange={handleChange} required />
        </div>
        <div className="owner-form-group">
          <label className="owner-form-label" htmlFor="status">Status</label>
          <select id="status" name="status" className="owner-form-select" value={form.status} onChange={handleChange}>
            <option value="active">Active</option>
            <option value="inactive">Inactive</option>
          </select>
        </div>
        <div className="owner-form-group trainer-form-full">
          <label className="owner-form-label" htmlFor="certifications">Certifications</label>
          <textarea
            id="certifications"
            name="certifications"
            className="owner-form-input owner-form-textarea"
            rows={3}
            value={form.certifications}
            onChange={handleChange}
            placeholder="One certification per line"
          />
        </div>
      </div>
      <div className="subscription-form-actions">
        <button type="submit" className="owner-btn owner-btn-primary">{submitLabel}</button>
        {onCancel && (
          <button type="button" className="owner-btn owner-btn-secondary" onClick={onCancel}>Cancel</button>
        )}
      </div>
    </form>
  );
}

export default TrainerForm;
